// extracted by mini-css-extract-plugin
export default {"root":"MenuBurgerButton_root__bslh+","item":"MenuBurgerButton_item__m3zgs","active":"MenuBurgerButton_active__xTTvp"};